module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAhCAYAAACvBDmYAAAAAXNSR0IArs4c6QAAAMxJREFUWAljdJ7z6z/DUABDwaEgNzINhcAEuXHIOJRloELUfc53vHmDhYXZZGsC21mY+4ZMiI46FBZl1KKHTIhiZCZCiZzSENqZwslIjhkYDiXHEHL0MDIy/sWn788/BpRSYcAcuiOZgyS7h24axRcd1JQjlBdGC3xqhjY2s4ZMGh11KLboo0SMpLKMEovQ9Y4W+OghQm/+gEX9aIFP76hGtw8j6sltL6IbTG3+aIFP7RDFiHpqW4DLvNECH1fI0Et8yGQmxqEw7AiKNQC8zy88Nkx1mAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/mixers/QuickSelection-04.png
// module id = 525
// module chunks = 2